import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import Alert from "components/atoms/alert/Alert";
import useLoading from "components/atoms/loading/useLoading";

import FormInput from "components/molecules/FormInput";
import AbstractModalFooter from "components/page/modal/AbstractModalFooter";

import { usePaymentPlanGroupUpdate } from "hooks/queries/usePayment";

import { genericEnterKeyDown } from "utils/validation";

const Container = styled.div`
    width: 100%;
`;

function PaymentGroupRenameModal(props) {
    const { exitModal } = props;

    const { setLoading } = useLoading();

    const inputRef = useRef(null);
    const paymentGroupUpdateMutation = usePaymentPlanGroupUpdate();
    const [name, setName] = useState(props.group?.name || "");

    const handleApply = () => {
        setLoading(true);
        paymentGroupUpdateMutation.mutate(
            { name: name, id: props.group?.id },
            {
                onSuccess: () => {
                    exitModal();
                    setLoading(false);
                },
                onError: (error) => {
                    setLoading(false);
                },
            },
        );
    };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    return (
        <Container>
            <FormInput
                labelDp="none"
                placeholder="Group Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={(e) => {
                    genericEnterKeyDown(e, () => {
                        if (!name) {
                            Alert("warn", "에러", "그룹 이름을 입력해주세요.");
                            return;
                        }
                        handleApply();
                    });
                }}
                ref={inputRef}
            />
            <AbstractModalFooter
                leftBtnText={"Cancel"}
                rightBtnText={"Rename"}
                leftOnClick={props.exitModal}
                rightOnClick={() => {
                    if (!name) {
                        Alert("warn", "에러", "그룹 이름을 입력해주세요.");
                        return;
                    }
                    handleApply();
                }}
            />
        </Container>
    );
}

export default PaymentGroupRenameModal;
